import { EDIT_USER, FETCH_USER_PROFILE, CLEAR_PROFILE, FETCH_CHANGE_PIN } from './types';

const BACKEND_API = 'BACKEND_API';

export const editUser = data => ({
  type: BACKEND_API,
  payload: {
    method: 'patch',
    url: '/portal/profile/',
    data,
    ...EDIT_USER
  }
});

export const fetchChangePin = data => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'post',
      url: '/users/change_pin/',
      data,
      ...FETCH_CHANGE_PIN
    }

  )
});

export const fetchUserProfile = () => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'get',
      url: '/portal/profile/'
    },
    FETCH_USER_PROFILE
  )
});

export const clearProfile = () => ({
  type: CLEAR_PROFILE
});
